const ALLOWED_LOGIN_DOMAINS = ['posti.fi', 'posti.com', 'tyvi.fi', 'posticloud.fi'] as const

export const isAllowedCorporateRecoveryLoginHost = (hostname: string): boolean => {
  const host = hostname.toLowerCase().replace(/\.$/, '')
  return ALLOWED_LOGIN_DOMAINS.some((domain) => host === domain || host.endsWith(`.${domain}`))
}

/**
 * Resolves the post-recovery Login button target from the `source` query param.
 * Only http(s) URLs whose hostname is an allowlisted Posti domain (or subdomain) are accepted.
 */
export const resolveCorporateRecoveryLoginUrl = (
  source: string | null,
  rewriteMap?: Record<string, string>
): string => {
  if (!source) {
    return ''
  }

  try {
    const parsed = new URL(source)

    if (parsed.protocol !== 'https:' && parsed.protocol !== 'http:') {
      return ''
    }

    if (!isAllowedCorporateRecoveryLoginHost(parsed.hostname)) {
      return ''
    }

    const rewriteKey = parsed.hostname + parsed.pathname
    return rewriteMap?.[rewriteKey] ?? parsed.origin
  } catch {
    return ''
  }
}
